module.exports = __webpack_public_path__ + "static/media/activity-dashboard.c78ee619.png";